module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columnTranslation"
  }, [_vm._l((_vm.value), function(translation, index) {
    return _c('div', {
      staticClass: "column"
    }, [_c('div', {
      staticClass: "field mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
    }, [_c('input', {
      ref: 'translation_key_' + translation.from,
      refInFor: true,
      staticClass: "mdl-textfield__input",
      attrs: {
        "type": "text",
        "id": 'translation_key_' + translation.from,
        "required": _vm.required
      },
      domProps: {
        "value": translation.from
      },
      on: {
        "input": function($event) {
          _vm.updateFrom(index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "mdl-textfield__label",
      attrs: {
        "for": 'translation_key_' + translation.from
      }
    }, [_vm._v("Translate From")])]), _vm._v(" "), _c('SingleSelect', {
      attrs: {
        "value": translation.to,
        "options": _vm.targets
      },
      on: {
        "input": function (value) { return _vm.updateTo(index, value); }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent del-translation",
      on: {
        "click": function($event) {
          _vm.deleteTranslation(index)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete_forever")])]), _vm._v(" "), (_vm.errors[index]) ? _c('div', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errors[index]))]) : _vm._e()], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent add-translation",
    on: {
      "click": _vm.addTranslation
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1212c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/config/ColumnTranslation.vue
// module id = 410
// module chunks = 1